import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { ProductionByStreetService } from 'src/app/modules/dashboard/services/production-by-street/production-by-street.service';
import { ProductionByTypetruckService } from 'src/app/modules/dashboard/services/production-by-typetruck/production-by-typetruck.service';
import { ProductionByStreetModalComponent } from '../../production-by-street/production-by-street-modal/production-by-street-modal.component';
import { firstLetterUpper } from '../../../../../../../../projects/common/src/app/services/utils/util.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { AuthenticationService } from 'projects/authentication/src/app/services';

@Component({
  selector: 'app-prod-vs-plan-modal',
  templateUrl: './prod-vs-plan-modal.component.html',
  styleUrls: ['./prod-vs-plan-modal.component.scss'],
})
export class ProdVsPlanModalComponent extends ProductionByStreetModalComponent implements OnInit, OnDestroy {
  public dataEstadistics: any;
  constructor(
    public activeModal: NgbActiveModal,
    protected prodByStreetService: ProductionByStreetService,
    protected prodByModel: ProductionByTypetruckService,
    protected langService: LanguageService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected authService: AuthenticationService,
  ) {
    super(activeModal, prodByStreetService, prodByModel, langService, googleAnalyticsService, authService);
  }

  ngOnInit() {
    const resultType = 2;
    this.streetLabelModalTitle = firstLetterUpper(this.langService.message('street'));
    this.extractionPointDetailSubscription = this.prodByStreetService
      .getExtractionPointDetailByStreet(this.date, this.shift.shiftId, this.streetId, resultType)
      .subscribe((data) => {
        this.modalData = data;
      });
    const modal = {
      modal_widget: 'production-by-street-vs-plan',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', modal);
    // 👮🏽 subscribe to the token expired event to close the modal
    this.logoutSub = this.authService.tokenExpired$.subscribe(() => {
      this.activeModal.dismiss('logout');
    });
  }

  public ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  public changeTab($event) {
    let customEvent = {};
    if ($event.index === 0) {
      customEvent = {
        tab_modal: 'production-by-street-vs-plan_chart',
      };
    }
    if ($event.index === 1) {
      customEvent = {
        tab_modal: 'production-by-street-vs-plan_statistics',
      };
      this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
    }
  }
}
